import { memo } from 'react';
import { OutlineWrapper } from './styled';

const Outline = memo(() => {
  return (
    <OutlineWrapper id="themePostScene" className="outlineFrame">
      <div className="--top">
        <div className="line --horizontal"></div>
        <div className="line --horizontal"></div>
      </div>
      <div className="--bottom">
        <div className="line --horizontal"></div>
        <div className="line --horizontal"></div>
      </div>
      <div className="--left">
        <div className="line --vertical"></div>
      </div>
      <div className="--right">
        <div className="line --vertical"></div>
        <div className="line --vertical"></div>
      </div>
    </OutlineWrapper>
  );
});

export default Outline;
